<template>
  <div class="form-container">
    <v-card class="pa-4" elevation="2">
      <v-card-title class="d-flex align-center">
        <v-spacer></v-spacer>
        <v-select class="year-select" :items="anolectivos" v-model="anolectivoSelected" @change="PesquisarEstudantes()"
          item-value="descricao" item-text="novadescricao" label="Ano letivo" outlined dense hide-details
          style="max-width: 200px"></v-select>
      </v-card-title>

      <EditarDados v-if="editarDados" :estudante="selectedStudent" @cancel="fecharComponente" />
      <CodigoAdesao v-if="editarCodigo" :estudante="selectedStudent" @cancel="fecharComponente" />
      <HistoricoAcademico v-if="historicoEst" :student="selectedStudent" @cancel="fecharComponente"  />

      <v-card-text>
        <loading v-if="isLoading" />

        <Tabela :headers="headers" :desserts="estudantes" :title="titulo" :icon="icone" @search="buscar">
          <template #item-action="{ item }">
            <v-menu offset-y left transition="slide-y-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" color="grey" class="action-btn" small>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="resetCode(item)">
                  <v-list-item-icon>
                    <v-icon color="green">mdi-lock-reset</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Código Adesão EducaSoft</v-list-item-title>
                </v-list-item>
                <v-list-item @click="editStudent(item)">
                  <v-list-item-icon>
                    <v-icon color="blue">mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Editar Dados</v-list-item-title>
                </v-list-item>
                
             
              <v-list-item @click="changeClass(item)">
                <v-list-item-icon>
                  <v-icon color="orange">mdi-account-switch</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Mudar de Turma</v-list-item-title>
              </v-list-item>

              
              <v-list-item @click="viewHistory(item)">
                <v-list-item-icon>
                  <v-icon color="orange">mdi-school</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Histórico acadêmico</v-list-item-title>
              </v-list-item>


              </v-list>
            </v-menu>
          </template>

          <template #item.nome="{ item }">
            <div class="student-name">
              <v-avatar size="36" color="primary" class="mr-2">
                <v-img v-if="item.foto" :src="item.foto"></v-img>
                <span v-else class="white--text">{{ getInitials(item.nome) }}</span>
              </v-avatar>
              {{ item.nome }}
            </div>
          </template>

          <template #item.situacao="{ item }">
            <v-chip small :color="getStatusColor(item.situacao)" dark>
              {{ item.situacao }}
            </v-chip>
          </template>
        </Tabela>
      </v-card-text>
    </v-card>
        <mudar-turma v-if="$store.state.mudarturma"  :estudante="estudanteSelected" @cancel="fecharMudarTurma" />
   </div>
</template>

<script>
import axios from "../../../plugins/axios";
import { mask } from "vue-the-mask";
const ls = require("local-storage");

import Tabela from "../componentes/configuracoes/Tabela.vue";
import EditarDados from "../componentes/estudante/EditarDados.vue";
import CodigoAdesao from "../componentes/estudante/CodigoAdesao.vue";
import HistoricoAcademico from "../componentes/estudante/HistoricoAcademico.vue";
import mudarTurma from "../componentes/estudante/mudarTurma.vue";
import Swal from 'sweetalert2';
 
export default {
  directives: { mask },
  components: {
    loading: () => import("../../../components/loading.vue"),
    Tabela,
    EditarDados,
    CodigoAdesao,
    HistoricoAcademico,
    mudarTurma
  },
  data: () => ({
    headers: [
      { text: '#', value: 'index', width: '50px', align: 'center' },
      { text: "Nome", align: "left", value: "nome", sortable: true },
      { text: "Documento", value: "bi", width: '150px' },
      { text: "Matrícula", value: "idMatricula", width: '120px' },
      { text: "Curso", value: "curso", width: '150px' },
      { text: "Turma", value: "turma", width: '100px' },
      { text: "Ano letivo", value: "anoLectivo", width: '120px' },
      { text: "Resultado", value: "resultado", width: '120px' },
      { text: "Situação", value: "situacao", width: '120px' },
      { text: "Data", value: "data_", width: '120px' },
      { text: "Ações", value: "action", sortable: false, width: '80px', align: 'center' },
    ],
    titulo: "Pesquisa de Estudantes",
    icone: "mdi-account-group",
    isLoading: true,
    anolectivos: [],
    anolectivoSelected: ls.get("anolectivo"),
    estudantes: [],
    editarDados: false,
    dialogo_turma: false,
    editarCodigo: false,
    selectedStudent: null,
    historicoEst: false
  }),

  watch: {
    estudantes() {
      this.isLoading = false;
      this.$store.state.isloading = false;
    }
  },

  created() {
    this.carregarDadosIniciais();
  },

  methods: {
    getInitials(name) {
      if (!name) return '';
      return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
    },

    getStatusColor(status) {
      const statusColors = {
        'Ativo': 'green',
        'Inativo': 'red',
        'Transferido': 'orange',
        'Graduado': 'blue',
        'default': 'grey'
      };
      return statusColors[status] || statusColors.default;
    },

    async carregarDadosIniciais() {
      this.isLoading = true;
      await Promise.all([
        this.initializeAnolectivo(),
        this.initialize()
      ]);
      this.isLoading = false;
    },

    buscar(valor) {
      this.initialize(valor);
    },

    PesquisarEstudantes() {
      this.initialize();
    },

    async initializeAnolectivo() {
      try {
        this.anolectivos = await axios.get("/listarAnoLectivoAll").then((res) => res.data);
      } catch (error) {
        this.handleError(error);
      }
    },

 async changeClass(item) {
   
   this.estudanteSelected = item;
   this.$store.dispatch('toggleMudarTurma', true); // abrir
},

    fecharComponente(bool) {
      this.editarDados = false;
      this.editarCodigo = false;
      this.historicoEst = false;
      this.selectedStudent = null;

      if (bool) {
        this.initialize();
      }
    },

    async initialize(searchInDb) {
      this.isLoading = true;
      try {
        const payload = searchInDb
          ? `{"find":"${searchInDb}"}`
          : '{"find":"all"}';

        this.estudantes = await axios
          .get(`/estudanteFindAll-geral/${payload}/${this.anolectivoSelected}`)
          .then((res) => res.data);

        ls.set("estudantes", this.estudantes);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },

    handleError(error) {
      this.text = error;
      this.$store.dispatch("textMessage", {
        msg: this.text,
        classMessage: "msgError",
        timeout: 3000,
      });
    },

    resetCode(item) {
      this.selectedStudent = item;
      this.editarCodigo = true;
    },

    editStudent(item) {
      this.selectedStudent = item;
      this.editarDados = true;
    },

    fecharMudarTurma (){
       this.dialogo_turma = false;
    },

 


    viewHistory(item) {
      this.selectedStudent = item;
      this.historicoEst = true;
      // this.$store.state.objaluno = item;
      // this.$router.push("historico-academico");
    }
  },
};
</script>

<style scoped>
.form-container {
  margin: 0 auto;
}

.year-select {
  margin-left: 20px;
}

.student-name {
  display: flex;
  align-items: center;
}

.action-btn {
  transition: all 0.3s ease;
}

.action-btn:hover {
  transform: scale(1.1);
}

.v-card-title {
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
  margin-bottom: 16px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .v-card-title {
    flex-direction: column;
    align-items: flex-start;
  }

  .year-select {
    margin-left: 0;
    margin-top: 10px;
    width: 100%;
    max-width: none;
  }
}



</style>